import { API_BASE_URL } from "../api/apiClient";

const PORTAL_BASE = "/api/v1/automap/dealer-portal";

export function fetchDealerDashboard(dealerId, range = "last_30_days") {
  const qs = new URLSearchParams({ range }).toString();
  return fetch(
    `${API_BASE_URL}${PORTAL_BASE}/dealers/${encodeURIComponent(dealerId)}/dashboard?${qs}`,
    { credentials: "include" }
  ).then(async (res) => {
    const data = await res.json();
    if (!res.ok) throw new Error(data.message || "Could not load dashboard.");
    return data;
  });
}

export function trackDashboardAnalytics(dealerId, eventType, metadata = {}) {
  return fetch(
    `${API_BASE_URL}${PORTAL_BASE}/dealers/${encodeURIComponent(dealerId)}/dashboard/events`,
    {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ eventType, ...metadata }),
    }
  ).catch(() => {});
}
